'use strict';
/*
  auth.js — thin wrapper around the shared PX7 Accounts browser client.
  The app id is "justpostit" (must match the registration in PX7 Accounts'
  apps.js and the JWT audience the Functions verify).
*/
import {
  authFetch, getStoredToken, loginWithPassword, signupWithPassword,
  requestPasswordReset, signOut, consumeReturn, AuthExpiredError,
} from '@px7digital/system-libraries/accounts-client';

export const APP = 'justpostit';

let onExpired = null;
export function setOnExpired(fn) { onExpired = fn; }

// fetch that attaches `Authorization: Bearer <token>` and refreshes once on 401.
// If the session is dead beyond repair, fire the expiry hook (→ show the gate).
export async function afetch(path, init = {}) {
  try {
    return await authFetch(path, { ...init, app: APP });
  } catch (e) {
    if (e instanceof AuthExpiredError && onExpired) onExpired();
    throw e;
  }
}

export {
  getStoredToken, loginWithPassword, signupWithPassword,
  requestPasswordReset, signOut, consumeReturn,
};
